export default __webpack_public_path__ + "static/discussions_debates-dd48f2e10dc0251308a4ee60f145a833.png";